import { TransferPlanningContainer } from "./container";

export const TransferPlanningPage = () => {
  return <TransferPlanningContainer />;
};
